import { useTranslation } from '@lt/localization';
import React from 'react';
import { formatPhone } from 'src/utils/stringUtils';
import styled from 'styled-components';
import type { ClientSummaryInfo } from '../../types';
import {
  TEST_ID_MOBILE_SUMMARY_CLIENT_CHANGE_BTN,
  TEST_ID_MOBILE_SUMMARY_CLIENT_NAME,
} from './constants';

type Props = {
  client?: ClientSummaryInfo;
  onClick: () => void;
};

const ClientSummary = (props: Props): JSX.Element | null => {
  const { client, onClick } = props;

  const { t } = useTranslation();

  if (!client) {
    return null;
  }

  return (
    <Wrapper>
      <Title>{t('checkout.summary.client.title')}</Title>
      <div>
        <div data-testid={TEST_ID_MOBILE_SUMMARY_CLIENT_NAME}>
          {client.name} {client.surname}
        </div>
        <PhoneAndEmail>
          {client.phone ? formatPhone(client.phone) : null} {client.email}
        </PhoneAndEmail>
      </div>
      <ChangeClientDataBtn
        data-testid={TEST_ID_MOBILE_SUMMARY_CLIENT_CHANGE_BTN}
        onClick={onClick}
      >
        {t('checkout.summary.client.buttonText')}
      </ChangeClientDataBtn>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  font-size: 14px;
  padding: 8px;
`;

const Title = styled.div`
  margin-bottom: 4px;
  font-size: 12px;
  line-height: 16px;
  color: #919499;
`;

const PhoneAndEmail = styled.div`
  color: #4d4d4d;
`;

const ChangeClientDataBtn = styled.div`
  margin-top: 4px;
  color: var(--secondary);
  cursor: pointer;
`;

export default ClientSummary;
